import { gql } from '@apollo/client';

export const GIFT_CARD_DELIVERY_PLACES = gql`
  query GiftCardDeliveryPlaces {
    servicePoints(first: 100, service: Branch) {
      edges {
        node {
          id
          region
          branches {
            name
            id
          }
        }
      }
    }
  }
`;
